import config from './config'

export const UserMngmt = {
    createUser: () => {
        return config.post('/api/account/users/')
    },
}
